export const MASTER_TYPE_SLUG = {
    DOCUMENT_TYPE: 'document_type',
    DOCUMENT_FORMAT: 'document_format',
    APPROVAL_DEPARTMENT: 'approval_unit',
    PROJECT_TYPE: 'project_type',
    INVESTOR: 'investor',
    FUNCTIONAL_DEPARTMENT: 'functional_department',
} as const
